// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── forgot-pin-new.css ─────────────────────────────────── */

.fp-root {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 8px;
}

/* ── shared label ───────────────────────────────────────── */
.fp-label {
  display: block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #94a3b8;
}

/* ── field group ────────────────────────────────────────── */
.fp-field-group {
  display: flex;
  flex-direction: column;
}

/* ── mobile row ─────────────────────────────────────────── */
.fp-mobile-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

/* ── mobile input wrapper ───────────────────────────────── */
.fp-input-wrap {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 6px 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.fp-input-wrap:focus-within {
  border-color: #2a71ff;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);
}

.fp-input-wrap--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.fp-prefix {
  border-radius: 16px;
  background-color: #f8fafc;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 700;
  color: #475569;
  white-space: nowrap;
  flex-shrink: 0;
}

.fp-input {
  flex: 1 1 0;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.fp-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.fp-input::-webkit-outer-spin-button,
.fp-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.fp-input[type="number"] {
  -moz-appearance: textfield;
}

.fp-input:disabled {
  cursor: not-allowed;
}

/* ── Send OTP button ────────────────────────────────────── */
.fp-send-otp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 56px;
  padding: 0 20px;
  border-radius: 24px;
  border: none;
  background-color: #2a71ff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.25);
  transition:
    background 0.15s,
    opacity 0.15s;
}

.fp-send-otp-btn:hover:not(:disabled) {
  background-color: #155eef;
}

.fp-send-otp-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Resend OTP button ──────────────────────────────────── */
.fp-resend-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 56px;
  padding: 0 16px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s,
    opacity 0.15s;
}

.fp-resend-btn:hover:not(.fp-resend-btn--disabled) {
  background-color: #f8fafc;
}

.fp-resend-btn--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── OTP card ───────────────────────────────────────────── */
.fp-otp-card {
  border-radius: 28px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition:
    border-color 0.3s,
    background-color 0.3s,
    opacity 0.3s;
}

.fp-otp-card--inactive {
  opacity: 0.4;
  pointer-events: none;
}

.fp-otp-card--active {
  border-color: #e2e8f0;
  background-color: #ffffff;
}

.fp-otp-card--verified {
  border-color: #6ee7b7;
  background-color: rgba(240, 253, 244, 0.5);
}

/* ── OTP card header ────────────────────────────────────── */
.fp-otp-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.fp-otp-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
}

.fp-otp-card-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* ── verified badge ─────────────────────────────────────── */
.fp-verified-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 9999px;
  background-color: #d1fae5;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 700;
  color: #065f46;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── OTP digit boxes row ────────────────────────────────── */
.fp-otp-boxes {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

/* ── individual OTP box ─────────────────────────────────── */
.fp-otp-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition:
    border-color 0.15s,
    background-color 0.15s,
    color 0.15s;
  overflow: hidden;
}

.fp-otp-box--verified {
  border-color: #6ee7b7;
  background-color: #ecfdf5;
  color: #065f46;
}

/* real input sitting inside each box */
.fp-otp-digit-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  caret-color: #2a71ff;
  padding: 0;
}

.fp-otp-digit-input:disabled {
  cursor: not-allowed;
}

/* ── PIN grid ───────────────────────────────────────────── */
.fp-pin-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  transition: opacity 0.3s;
}

@media (max-width: 480px) {
  .fp-pin-grid {
    grid-template-columns: 1fr;
  }
}

.fp-pin-grid--inactive {
  opacity: 0.4;
  pointer-events: none;
}

/* ── PIN input ──────────────────────────────────────────── */
.fp-pin-input {
  display: flex;
  width: 100%;
  height: 56px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0 16px;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  outline: none;
  box-sizing: border-box;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.fp-pin-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.fp-pin-input:focus {
  border-color: #2a71ff;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);
}

.fp-pin-input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* ── action buttons row ─────────────────────────────────── */
.fp-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 4px;
}

@media (max-width: 400px) {
  .fp-actions {
    grid-template-columns: 1fr;
  }
}

/* ── Cancel / Back button ───────────────────────────────── */
.fp-cancel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #334155;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s;
}

.fp-cancel-btn:hover {
  background-color: #f8fafc;
}

/* ── Reset PIN button ───────────────────────────────────── */
.fp-reset-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 24px;
  border: none;
  background-color: #2a71ff;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 22px 50px rgba(42, 113, 255, 0.35);
  transition:
    background 0.15s,
    opacity 0.15s;
}

.fp-reset-btn:hover:not(:disabled) {
  background-color: #155eef;
}

.fp-reset-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.fp-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #fff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  animation: fp-spin 0.8s linear infinite;
}

@keyframes fp-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/forgot-pin/forgot-pin.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+CAA+C;EAC/C;;iBAEe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;;iBAEe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC;;;gBAGc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC;;;eAGa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB;;oBAEkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD;;iBAEe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ── forgot-pin-new.css ─────────────────────────────────── */\n\n.fp-root {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 8px;\n}\n\n/* ── shared label ───────────────────────────────────────── */\n.fp-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  color: #94a3b8;\n}\n\n/* ── field group ────────────────────────────────────────── */\n.fp-field-group {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── mobile row ─────────────────────────────────────────── */\n.fp-mobile-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n\n/* ── mobile input wrapper ───────────────────────────────── */\n.fp-input-wrap {\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 6px 12px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.fp-input-wrap:focus-within {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);\n}\n\n.fp-input-wrap--disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.fp-prefix {\n  border-radius: 16px;\n  background-color: #f8fafc;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #475569;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.fp-input {\n  flex: 1 1 0;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  height: 44px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.fp-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.fp-input::-webkit-outer-spin-button,\n.fp-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.fp-input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.fp-input:disabled {\n  cursor: not-allowed;\n}\n\n/* ── Send OTP button ────────────────────────────────────── */\n.fp-send-otp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  height: 56px;\n  padding: 0 20px;\n  border-radius: 24px;\n  border: none;\n  background-color: #2a71ff;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.25);\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n}\n\n.fp-send-otp-btn:hover:not(:disabled) {\n  background-color: #155eef;\n}\n\n.fp-send-otp-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Resend OTP button ──────────────────────────────────── */\n.fp-resend-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  height: 56px;\n  padding: 0 16px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n}\n\n.fp-resend-btn:hover:not(.fp-resend-btn--disabled) {\n  background-color: #f8fafc;\n}\n\n.fp-resend-btn--disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ── OTP card ───────────────────────────────────────────── */\n.fp-otp-card {\n  border-radius: 28px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  transition:\n    border-color 0.3s,\n    background-color 0.3s,\n    opacity 0.3s;\n}\n\n.fp-otp-card--inactive {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.fp-otp-card--active {\n  border-color: #e2e8f0;\n  background-color: #ffffff;\n}\n\n.fp-otp-card--verified {\n  border-color: #6ee7b7;\n  background-color: rgba(240, 253, 244, 0.5);\n}\n\n/* ── OTP card header ────────────────────────────────────── */\n.fp-otp-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.fp-otp-card-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 4px 0;\n}\n\n.fp-otp-card-desc {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n/* ── verified badge ─────────────────────────────────────── */\n.fp-verified-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 9999px;\n  background-color: #d1fae5;\n  padding: 4px 12px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #065f46;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ── OTP digit boxes row ────────────────────────────────── */\n.fp-otp-boxes {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 8px;\n}\n\n/* ── individual OTP box ─────────────────────────────────── */\n.fp-otp-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  border-radius: 18px;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition:\n    border-color 0.15s,\n    background-color 0.15s,\n    color 0.15s;\n  overflow: hidden;\n}\n\n.fp-otp-box--verified {\n  border-color: #6ee7b7;\n  background-color: #ecfdf5;\n  color: #065f46;\n}\n\n/* real input sitting inside each box */\n.fp-otp-digit-input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  background: transparent;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  caret-color: #2a71ff;\n  padding: 0;\n}\n\n.fp-otp-digit-input:disabled {\n  cursor: not-allowed;\n}\n\n/* ── PIN grid ───────────────────────────────────────────── */\n.fp-pin-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  transition: opacity 0.3s;\n}\n\n@media (max-width: 480px) {\n  .fp-pin-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fp-pin-grid--inactive {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n/* ── PIN input ──────────────────────────────────────────── */\n.fp-pin-input {\n  display: flex;\n  width: 100%;\n  height: 56px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0 16px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  outline: none;\n  box-sizing: border-box;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.fp-pin-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.fp-pin-input:focus {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);\n}\n\n.fp-pin-input:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* ── action buttons row ─────────────────────────────────── */\n.fp-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n@media (max-width: 400px) {\n  .fp-actions {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Cancel / Back button ───────────────────────────────── */\n.fp-cancel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 56px;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  color: #334155;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.fp-cancel-btn:hover {\n  background-color: #f8fafc;\n}\n\n/* ── Reset PIN button ───────────────────────────────────── */\n.fp-reset-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 56px;\n  border-radius: 24px;\n  border: none;\n  background-color: #2a71ff;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 22px 50px rgba(42, 113, 255, 0.35);\n  transition:\n    background 0.15s,\n    opacity 0.15s;\n}\n\n.fp-reset-btn:hover:not(:disabled) {\n  background-color: #155eef;\n}\n\n.fp-reset-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.fp-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid #fff;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 8px;\n  animation: fp-spin 0.8s linear infinite;\n}\n\n@keyframes fp-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
